import { configureStore } from '@reduxjs/toolkit';
import settingReducer from './setting/reducers';
import authReducer from './slices/authSlice';
export const store = configureStore({
  reducer: {
    setting: settingReducer,
    auth: authReducer
  }
});
